// src/pages/accounting/collateralReceived/index.jsx
import React from 'react';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../contexts/LanguageContext';
import useCollateralReceivedData from './hooks/useCollateralReceivedData';
import useCollateralReceivedForm from './hooks/useCollateralReceivedForm';
import CollateralReceivedFilter from './components/CollateralReceivedFilter';
import CollateralReceivedTable from './components/CollateralReceivedTable';
import CollateralReceivedFormDialog from './components/CollateralReceivedFormDialog';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportCollateralReceivedToExcelQuery } from '../../../api/endpoints/collateralReceived';


const CollateralReceivedPage = () => {
    const { th } = useLanguage();

    const { rows, loading, totalCount, pagination, onPageChange, draftFilters, setDraftField, canBrowseAllDealers, options, exportParams, handleApplyFilters, handleResetFilters, handleDelete } = useCollateralReceivedData();

    const formProps = useCollateralReceivedForm({ options });

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('collateralReceived.title')}</h1>
                <div className="flex gap-2">
                    <GenericFileExportButton
                        useExportQuery={useLazyExportCollateralReceivedToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'alinan_teminatlar.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                    <Button label={th('collateralReceived.add')} icon="pi pi-plus" severity="success" onClick={formProps.openAdd} />
                </div>
            </div>

            <CollateralReceivedFilter
                th={th}
                canBrowseAllDealers={canBrowseAllDealers}
                draftFilters={draftFilters}
                setDraftField={setDraftField}
                options={options}
                onApply={handleApplyFilters}
                onReset={handleResetFilters}
            />

            <CollateralReceivedTable th={th} data={rows} totalRecords={totalCount} pagination={pagination} onPage={onPageChange} loading={loading} onEdit={formProps.openEdit} onDelete={handleDelete} canBrowseAllDealers={canBrowseAllDealers} />

            <CollateralReceivedFormDialog
                th={th}
                visible={formProps.visible}
                onHide={formProps.close}
                editMode={formProps.editMode}
                form={formProps.form}
                errors={formProps.errors}
                setField={formProps.setField}
                dealerFieldDisabled={formProps.dealerFieldDisabled}
                currencyOptions={formProps.currencyOptions}
                onSave={formProps.save}
                saving={formProps.saving}
            />
        </div>
    );
};

export default CollateralReceivedPage;
